export default __webpack_public_path__ + "static/media/72_desktop.21ac2936.jpg";